const carouselItems = [
  {
    title: '科幻电影宇宙',
    desc: '从《流浪地球》到《星际穿越》，探索人类想象力的边界',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20nebula%20and%20distant%20planets%2C%20cosmic%20landscape%2C%20deep%20blue%20and%20purple%20hues%20with%20golden%20star%20light%2C%20cinematic%20wide%20composition%2C%20atmospheric%2C%20no%20text%2C%20no%20people%2C%20breathtaking&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '22部合集',
    color: 'from-blue-900/80',
  },
  {
    title: '宫斗权谋剧场',
    desc: '《甄嬛传》《如懿传》《琅琊榜》经典古装大剧全收录',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20with%20red%20lanterns%20and%20ornate%20architecture%2C%20golden%20roof%20details%2C%20misty%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20warm%20lighting%2C%20historical%20drama%20style%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '18部合集',
    color: 'from-red-900/80',
  },
  {
    title: '悬疑烧脑专场',
    desc: '高智商推理与心理悬疑，每一步都让人屏息凝神',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20dramatic%20shadow%20and%20light%20play%2C%20vintage%20detective%20atmosphere%2C%20old%20wooden%20furniture%20with%20dim%20lamp%20light%2C%20noir%20aesthetic%2C%20foggy%20ambiance%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '31部合集',
    color: 'from-slate-900/80',
  },
  {
    title: '热血动漫世界',
    desc: '《海贼王》《咒术回战》《进击的巨人》追番不停歇',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20sky%20with%20dramatic%20clouds%20and%20energy%20waves%2C%20dynamic%20color%20burst%2C%20golden%20and%20crimson%20sunset%20hues%2C%20fantasy%20adventure%20atmosphere%2C%20epic%20composition%2C%20no%20text%2C%20no%20characters&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '50部合集',
    color: 'from-orange-900/80',
  },
  {
    title: '韩剧热播专区',
    desc: '《黑暗荣耀》《鱿鱼游戏》现象级韩剧一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20urban%20night%20scene%20with%20neon%20signs%20and%20rainy%20street%2C%20warm%20glowing%20city%20lights%2C%20romantic%20cinematic%20atmosphere%2C%20soft%20focus%2C%20dramatic%20mood%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '42部合集',
    color: 'from-pink-900/80',
  },
  {
    title: '经典港片回顾',
    desc: '《无间道》《英雄本色》《古惑仔》黄金年代永不褪色',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%20at%20dusk%20with%20neon%20signs%20and%20busy%20streets%2C%20vintage%20cinematic%20aesthetic%2C%20warm%20golden%20tones%2C%20retro%20atmosphere%2C%20classic%20film%20noir%20style%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=carousel-06&orientation=landscape',
    tag: '58部合集',
    color: 'from-amber-900/80',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500">精选主题策划，每一期都是视觉盛宴</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group relative rounded-lg overflow-hidden aspect-[3/2] cursor-pointer"
            >
              <img
                src={item.img}
                alt={item.title}
                title={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${item.color} via-transparent to-transparent`}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-50 group-hover:text-primary-400 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}